export default __webpack_public_path__ + "static/media/video-2016.52321011.webp";